import { HashLink as Link } from 'react-router-hash-link';
import Translation from '../Translation/cont/Translation';

const WrapperAccordion = ({transId, id, isProgram, selectionActiveClass, collapseActiveSelection, className, headerComponent = '', editComponent= '', children, editSelection, activeSelectionAccordionValue, gapless}) => {
    const titleOnClick = () => {
        if(!activeSelectionAccordionValue) {
            collapseActiveSelection(selectionActiveClass)
        } else {
            editSelection(false)
            collapseActiveSelection(selectionActiveClass)
        }
    }

    const getID = () => {
        if(id) {
            return id
        } else {
            return transId
        }
    }     
    
    const programmClassName = () => {
        if(isProgram) {
            return selectionActiveClass
        } else {
           return 'selections-item-content accordion-item ' + selectionActiveClass
        }
    }
    
    const getTitle = () => {
        if(transId) {
            return (
                <h3 className="selections-item-title accordion-header site-content-wrapper-inner title-large-light" onClick={() => titleOnClick()}>
                    <Link to={"#" + getID()}><span><Translation id={transId} /></span></Link>
                </h3>
            )
        } else {
            return ''
        }
    }

    let gap = ''

    if(!gapless) {
        gap = "gap-50 "
    }

    return (
        <div id={getID()} className={gap + "selections-item header-" + selectionActiveClass + ' ' + className}>
            {getTitle()}
            {headerComponent}
            {editComponent}
            <div className={programmClassName()}>
                {children}
            </div>
        </div>
    )
}
export default WrapperAccordion